export default "__VITE_ASSET__CooXoI11__"